import { CheckCircle2, AlertTriangle, Copy } from "lucide-react";

export function BollaMeta({ meta }) {
  if (!meta || (meta.quadra == null && !meta.duplicato)) return null;
  return (
    <div className="space-y-2 mb-4" data-testid="bolla-meta">
      {meta.duplicato && (
        <div data-testid="meta-duplicato" className="flex items-center gap-2 text-sm rounded-md px-3 py-2 bg-red-500/10 border border-red-500/40 text-red-300">
          <Copy className="w-4 h-4" /> Bolla con stesso numero e fornitore già registrata.
        </div>
      )}
      {meta.quadra === true && (
        <div data-testid="meta-quadra-ok" className="flex items-center gap-2 text-sm rounded-md px-3 py-2 bg-emerald-500/10 border border-emerald-500/40 text-emerald-300">
          <CheckCircle2 className="w-4 h-4" /> Totale documento € {Number(meta.totale_documento).toFixed(2)} — quadra con le righe ✓
        </div>
      )}
      {meta.quadra === false && (
        <div data-testid="meta-quadra-ko" className="flex items-center gap-2 text-sm rounded-md px-3 py-2 bg-red-500/10 border border-red-500/40 text-red-300">
          <AlertTriangle className="w-4 h-4" /> Totale documento € {Number(meta.totale_documento).toFixed(2)} ≠ calcolato € {Number(meta.totale_ivato ?? meta.totale_calcolato).toFixed(2)} — controlla le righe.
        </div>
      )}
    </div>
  );
}
